import React from 'react'
import LoadingSpinner from './LoadingSpinner'

const LoadingOverlay = ({ isVisible, text = 'Chargement...' }) => {
  if (!isVisible) return null

  return (
    <div className='loading-overlay-full'>
      <div className='loading-content'>
        <LoadingSpinner size='xl' />
        <p className='loading-message'>{text}</p>
      </div>
    </div>
  )
}

export default LoadingOverlay
